/*eslint-disable sort-keys */
const savedItemSortOrders = [
    'saleStart',
    '-saleStart',
    '-saved',
    'saved',
    '-viewed',
    'viewed',
    '-relevance',
    '-estimatedPrice',
    'lotNumber',
    '-bidCount',
    '-publishDate',
    '-currentBid',
    'promoted',
    '-hammerPrice',
] as const;

export default savedItemSortOrders;
